import { Dispatch } from '@reduxjs/toolkit'
import { loginRequest, loginSuccess, loginFailure, logout } from './slice'
import { AuthError } from './types'
import axios from '../../config/axios'
import { AxiosError } from 'axios'

export const googleLogin = () => async (dispatch: Dispatch) => {
  try {
    dispatch(loginRequest('Redirecting to Google...'))
    const response = await axios.get('/google/auth')
    const authUrl = response.data

    // Check if the response URL contains hd=telusinternational.com
    if (authUrl.includes('hd=telusinternational.com')) {
      dispatch(loginRequest('Redirecting to OneLogin...'))
    }

    window.location.href = authUrl
  } catch (error: unknown) {
    if (error instanceof AxiosError && error.response?.data?.error) {
      dispatch(loginFailure(error.response.data.error as AuthError))
    } else {
      dispatch(
        loginFailure({
          message: 'Failed to initiate Google login',
          details: 'Unknown error occurred',
        }),
      )
    }
  }
}

export const handleGoogleRedirect =
  (code: string, state: string, scope: string, authuser: string, hd: string, prompt: string) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(loginRequest('Redirecting to Google...'))
      const response = await axios.get('/google/redirect', {
        params: {
          code,
          state,
          scope,
          authuser,
          hd,
          prompt,
        },
      })

      if (response.data.success) {
        dispatch(loginSuccess(response.data.data))
        sessionStorage.setItem('lastActiveTime', Date.now().toString())
      } else if (response.data.error) {
        dispatch(loginFailure(response.data.error))
      }
    } catch (error: unknown) {
      if (error instanceof AxiosError && error.response?.data?.error) {
        dispatch(loginFailure(error.response.data.error as AuthError))
      } else {
        dispatch(
          loginFailure({
            message: 'Failed to complete Google login',
            details: 'Unknown error occurred',
          }),
        )
      }
    }
  }

export const logoutUser = () => async (dispatch: Dispatch) => {
  try {
    await axios.post('/logout')
    dispatch(logout())
  } catch (error) {
    console.error('Logout failed', error)
  }
}
